import { request, post } from '@/axios';

/**
 * @description: 检查是否有通话
 * @param
 * @return {*}
 */
export function checkOrder() {
  return request({
    url: '/anonymous/checkOrder',
    method: 'GET'
  });
}

/**
 * @description: 增加聊天次数
 * @param
 * @return {*}
 */
export function plusCount() {
  return post('/anonymous/plusCount');
}
/**
 * @description: 创建匿名聊天
 * @param
 * @return {*}
 */
export function createAnonymousCall(params) {
  return post('/anonymous/create', params);
}

/**
 * @description: 获取房间详情
 * @param {“roomUid”: 房间id}
 * @return {*}
 */
export function getDetail(params) {
  return post('/anonymous/dynamic', params);
}

/**
 * @description: 加入房间
 * @param
 * @return {*}
 */
export function joinRoom() {
  return post('/anonymous/joinRoom');
}

/**
 * @description: 公开数据
 * @param
 * {
 *	“roomUid”:””,
 *“userUuid”:””,
 *“type”:”用户类型:1/发起者 2/接单者”
 * }
 * @return {*}
 */
export function publishData(params) {
  return post('/anonymous/unveil', params);
}

/**
 * @description: 续时间
 * @param
 * {
 *	“roomUid”:””
 * }
 * @return {*}
 */
export function continuous(params) {
  return post('/anonymous/continuous', params);
}
/**
 * @description: 离开房间
 * @param
 * {
 *	“roomUid”:””
 * }
 * @return {*}
 */
export function leaveRoom(params) {
  return post('/anonymous/leaveRoom', params);
}

/**
 * @description: 获取通话次数
 * @param
 * @return {*}
 */
export function getCount() {
  return request({
    url: '/anonymous/getCount',
    method: 'GET'
  });
}

/**
 * @description: 获取声网配置
 * @param {roomUid:number|string} params
 * @return {*}
 */
export function getToken(params) {
  return request({
    url: '/voiceRoom/normal/get/token',
    method: 'get',
    params
  });
}